import React from 'react';
import { useAdminTheme } from '../context/AdminThemeContext';

const AdminDashboard: React.FC = () => {
  const { colors } = useAdminTheme();

  return (
    <div className="animate-fade-in-up">
      <h2 className={`text-2xl font-bold mb-6 ${colors.navbarText}`}>Dashboard Overview</h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {/* Card 1 */}
        <div className={`p-6 rounded-xl shadow-sm border ${colors.cardBg} ${colors.cardText} ${colors.borderColor} hover:shadow-md transition`}>
          <p className="text-sm font-medium uppercase tracking-wide opacity-70">Total Students</p>
          <h3 className="text-4xl font-bold mt-2">1,245</h3>
          <div className="mt-4 text-xs font-bold bg-green-100 text-green-700 inline-block px-2 py-1 rounded">
              +12% from last month
          </div>
        </div>

        {/* Card 2 */}
        <div className={`p-6 rounded-xl shadow-sm border ${colors.cardBg} ${colors.cardText} ${colors.borderColor} hover:shadow-md transition`}>
           <p className="text-sm font-medium uppercase tracking-wide opacity-70">Pending Queries</p>
           <h3 className={`text-4xl font-bold mt-2 ${colors.accentColor}`}>18</h3>
           <div className="mt-4 text-xs font-bold bg-red-100 text-red-600 inline-block px-2 py-1 rounded">
              Action required
          </div>
        </div>

        {/* Card 3 */}
        <div className={`p-6 rounded-xl shadow-sm border ${colors.cardBg} ${colors.cardText} ${colors.borderColor} hover:shadow-md transition`}>
           <p className="text-sm font-medium uppercase tracking-wide opacity-70">Active Courses</p>
           <h3 className="text-4xl font-bold text-blue-500 mt-2">12</h3>
           <div className={`mt-4 text-xs font-bold inline-block px-2 py-1 rounded bg-gray-100 text-gray-600`}>
              Updated today
          </div>
        </div>
      </div>

      <div className={`rounded-xl shadow-sm border h-96 flex flex-col items-center justify-center ${colors.cardBg} ${colors.borderColor} ${colors.cardText}`}>
          <p className="opacity-50">Recent Activities Graph will appear here.</p>
      </div>
    </div>
  );
};

export default AdminDashboard;